<div class="tooltip-container">
  <div class="text-limiter-tooltip">
    {{ text }}
  </div>
</div>
